(() => {
  if (window.__dsBundleReviewRouting) return;
  window.__dsBundleReviewRouting = true;
  const hosts = new Set([location.hostname, 'deadsoxy.com', 'deadsoxy-store.myshopify.com']);
  function update(root = document) {
    const links = [...root.querySelectorAll('a[href]')];
    if (root.matches?.('a[href]')) links.push(root);
    for (const link of links) {
      try {
        const url = new URL(link.getAttribute('href'), location.href);
        if (!/^https?:$/.test(url.protocol) || !hosts.has(url.hostname) || url.pathname.replace(/\/$/, '') !== '/products/holiday-bundle-builder') continue;
        url.pathname = '/products/build-your-bundle';
        url.searchParams.set('view', 'ds-bundle-review');
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch {}
    }
  }
  update();
  document.addEventListener('shopify:section:load', event => update(event.target));
  window.addEventListener('pageshow', () => update());
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) update(node);
  }).observe(document.body, {childList: true, subtree: true});
})();
